import history from '@utils/history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import deferredActionDispatch from '@redux/middlewares/deferredActionDispatch'
import createReducer from '@reducers'
// import logger from 'redux-logger'

const configureStore = (initialState = {}) => {
  let composeEnhancers = compose
  const reduxSagaMonitorOptions = {}

  if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
    // @ts-ignore
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    }
  }

  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions)
  const middleware = [
    deferredActionDispatch,
    sagaMiddleware,
    routerMiddleware(history)
  ]
  const enhancers = [applyMiddleware(...middleware)]

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(...enhancers)
  )

  store.runSaga = sagaMiddleware.run
  store.injectedReducers = {}
  store.injectedSagas = {}

  if (module.hot) {
    module.hot.accept('@reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers))
    })
  }
  return store
}

const initialState = {}
const store = configureStore(initialState)

export default store
